module.exports = __webpack_public_path__ + "94c4c72411cdd9af7ca75db5e1ac5da6.pdf";